import Flex from "common/Boxes/Flex";
import { TIER_TO_DISPLAY_NAME } from "features/affiliation/common/constants";
import Tag from "common/Tags/Tag";
import { typography } from "@shared/common/Themes/typography";
import { BoldTitle, SmallText } from "features/affiliation/common/styles";
import { CSSProperties } from "react";
import { useTheme } from "styled-components";
import { Tier } from "types/affiliation.types";
import useMedia from "utils/hooks/useMedia";
import { TABLET } from "common/constants";
import Progress from "common/Progress/Progress";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

import { LanguageNameSpaces } from "@shared/types";

interface TiersProgressProps {
  currentTierData?: Tier;
  numActivePaidUsers: number;
  showPercentage?: boolean;
  style?: CSSProperties;
}

const TiersProgress = ({
  currentTierData,
  numActivePaidUsers,
  showPercentage,
  style,
}: TiersProgressProps) => {
  const appTheme = useTheme();
  const isTablet = useMedia([`(max-width: ${TABLET})`], [true], false);
  const { t } = useTypedTranslation(LanguageNameSpaces.AFFILIATION);

  if (currentTierData) {
    const currentTier = currentTierData?.tier;
    const usersToUnlockNextTier = currentTierData.top - numActivePaidUsers;
    const progressPercent = (numActivePaidUsers / currentTierData.top) * 100;
    const commissionPercent = currentTierData.commission_rate * 100;

    return (
      <div style={style}>
        <Flex>
          <BoldTitle $isTablet={isTablet}>
            {t("tiers.tier_with_name", {
              tier: currentTier,
              name: t(TIER_TO_DISPLAY_NAME[currentTier]),
            })}
          </BoldTitle>
          <Tag
            color={appTheme.colors.green}
            style={{ width: "fit-content", fontSize: typography.fontSizes.S }}
          >
            {t("tiers.commission_tag", { percent: commissionPercent })}
          </Tag>
        </Flex>
        <Progress
          strokeColor={{
            "0%": appTheme.colors.primaryBlue,
            "100%": appTheme.colors.blues[3],
          }}
          percent={progressPercent}
          showInfo={showPercentage}
        />
        <Flex>
          <SmallText>
            {t("tiers.invite_to_unlock", {
              num: usersToUnlockNextTier,
              nextTier: currentTier + 1,
            })}
          </SmallText>
        </Flex>
      </div>
    );
  }
  return <></>;
};

export default TiersProgress;
